const loadImageFromUrl = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (error) => reject(error);
    img.crossOrigin = 'anonymous';
    img.src = url;
  });

export const getImageDimensions = async (file) => {
  const url = URL.createObjectURL(file);
  try {
    const img = await loadImageFromUrl(url);
    return { width: img.naturalWidth, height: img.naturalHeight };
  } finally {
    URL.revokeObjectURL(url);
  }
};

export const createThumbnailBlob = async (file, maxSize = 512, quality = 0.85) => {
  const url = URL.createObjectURL(file);
  try {
    const img = await loadImageFromUrl(url);
    const { naturalWidth, naturalHeight } = img;
    const maxDim = Math.max(naturalWidth, naturalHeight);
    const scale = maxDim > maxSize ? maxSize / maxDim : 1;
    const targetWidth = Math.max(1, Math.round(naturalWidth * scale));
    const targetHeight = Math.max(1, Math.round(naturalHeight * scale));
    const canvas = document.createElement('canvas');
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (result) => {
          if (!result) {
            reject(new Error('Unable to create thumbnail.'));
            return;
          }
          resolve(result);
        },
        'image/jpeg',
        quality,
      );
    });
    return blob;
  } finally {
    URL.revokeObjectURL(url);
  }
};

export const getFallbackThumbDataUrl = (type) => {
  const label = type === 'pdf' ? 'PDF' : 'SVG';
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
      <rect width="240" height="240" rx="24" fill="#1f1f1f"/>
      <rect x="24" y="24" width="192" height="192" rx="18" fill="#2a2a2a" stroke="#3a3a3a"/>
      <text x="120" y="132" text-anchor="middle" font-family="Inter, sans-serif" font-size="48" fill="#c9a962">
        ${label}
      </text>
    </svg>
  `.trim();
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};
